import { createSlice } from "@reduxjs/toolkit";
import { request } from "@/utils";
import {
    setToken as _setToken,
    getToken,
    removeToken
} from '@/utils';
import { setCid as _setCid, getCid, removeCid } from '@/utils';
import { refreshSession } from '@/utils/request';
import { fetchAgentCapabilities, resetAgentState } from './agent';
import { fetchMembership, resetMembership } from './membership';

const userStore = createSlice({
    name: "user",
    // 数据状态
    initialState: {
        token: getToken() || '',
        cid: getCid() || '',
        authStatus: 'initializing',
    },
    // 同步修改方法
    reducers: {
        setToken(state, action) {
            state.token = action.payload;
            _setToken(action.payload);
            state.authStatus = action.payload ? 'authenticated' : 'anonymous';
        },
        setCid(state, action) {
            state.cid = action.payload;
            _setCid(action.payload);
        },
        clearAuth(state) {
            state.token = '';
            state.cid = '';
            state.authStatus = 'anonymous';
            removeToken();
            removeCid();
        }
    }
});

// 解构
const { setToken, setCid, clearAuth } = userStore.actions;

// 获取 reducer
const userReducer = userStore.reducer;

// 获取用户登录
const fetchLogin = (loginForm) => {
    return async (dispatch) => {
        try {
            const normalizedForm = {
                ...loginForm,
                userName: (loginForm?.userName || '').trim()
            };
            const res = await request.post('/user/login', normalizedForm);
            if (!res?.succeed) {
                throw new Error(res?.errorMessage || '登录失败');
            }

            const loginData = res.data || {};
            if (!loginData.accessToken) {
                throw new Error('登录状态初始化失败，请重新登录');
            }

            dispatch(resetAgentState());
            dispatch(resetMembership());
            dispatch(setToken(loginData.accessToken));
            dispatch(setCid(loginData.cid || ''));
            dispatch(fetchMembership());
            dispatch(fetchAgentCapabilities());
            return res;
        } catch (error) {
            const errorCode = error?.code || error?.response?.data?.returnCode;
            if (errorCode === 'ERR_NETWORK') {
                throw new Error('暂时无法连接系统，请检查网络后重试');
            }
            if (errorCode === 'ECONNABORTED') {
                throw new Error('处理时间较长，请稍后重试');
            }
            throw error;
        }
    };
};

const restoreSession = () => {
    return async (dispatch, getState) => {
        try {
            const res = await refreshSession();
            const loginData = res?.data || {};
            if (!loginData.accessToken) {
                throw new Error('登录状态恢复失败');
            }
            if (getState().user.authStatus !== 'initializing') {
                return res;
            }
            dispatch(setToken(loginData.accessToken));
            dispatch(setCid(loginData.cid || ''));
            dispatch(fetchMembership());
            dispatch(fetchAgentCapabilities());
            return res;
        } catch (error) {
            if (getState().user.authStatus === 'initializing') {
                dispatch(clearAuth());
            }
            return null;
        }
    };
};

export { fetchLogin, restoreSession, setToken, setCid, clearAuth };
export default userReducer;
